<template>
  <div>
    <div v-show="saving" class="mask middle-level"></div>

    <div v-for="(item, k) in options" :key="k">
      <mu-row class="subject-option-type-text">
        <mu-col span="12" class="subject-option">
          <div ref="control" class="subject-flex">
            <!-- 单选题 选项 -->
            <mu-radio
              v-if="type === 1"
              v-model="radio"
              :disabled="disableForm || !changable"
              :value="item.id"
              class="subject-option-button"
              @click="clickOption()"
            ></mu-radio>

            <!-- 多选题 选项 -->
            <mu-checkbox
              v-if="type === 2"
              v-model="checkbox"
              :disabled="disableForm || !changable"
              :value="item.id"
              class="subject-option-button"
              @click="clickOption()"
            ></mu-checkbox>

            <!-- 判断题 选项 -->
            <mu-radio
              v-if="type === 5"
              v-model="radio"
              :disabled="disableForm || !changable"
              :value="item.id"
              class="subject-option-button"
              @click="clickOption(item.id)"
            ></mu-radio>
          </div>
          <!-- 判断题选项内容是图标 需要转义 其他题型为了不进行转义直接放在标签外 -->
          <div
            v-if="type === 5"
            class="subject-option-text"
            @click="hitControl(k)"
            v-html="optStr(k, item.title)"
          ></div>
          <div v-else class="subject-option-text" @click="hitControl(k)">
            {{ optStr(k, item.title) }}
          </div>
        </mu-col>
        <div class="pic-video">
          <!-- 图片类标题 -->
          <div v-show="item.pic" class="subject-title-icon">
            <img :src="item.pic" />
          </div>
          <!-- 视频 -->
          <video
            v-if="item.video"
            ref="video"
            :src="item.video.PlayURL"
            :poster="item.video.cover"
            webkit-playsinline="true"
            class="video"
            x5-playsinline="true"
            playsinline
            controlsList="nodownload"
            preload="auto"
            controls
          >
            不支持 video 标签
          </video>
        </div>
      </mu-row>
    </div>

    <subject-analysis
      v-show="showAnalysis"
      :is-true="isCorrect"
      :answer-opt="ansOptStr"
      :analysis-str="analysisStr"
    ></subject-analysis>

    <div class="answer-btns">
      <mu-button v-if="btnUp" class="btn-item up" @click="emitUp">
        上一题
      </mu-button>
      <mu-button class="btn-item down" @click="emitDown">
        下一题
      </mu-button>
    </div>
    <mu-dialog title="提示" width="360" :open.sync="openSimple">
      {{ dialogText }}
      <mu-button
        slot="actions"
        flat
        color="primary"
        @click="openSimple = false"
      >
        确认
      </mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import SubjectAnalysis from '@/components/SubjectAnalysis'
export default {
  components: { SubjectAnalysis },
  filters: {},
  props: {
    // 第几题
    index: Number,
    questionId: Number,
    // 题目类型
    type: Number,
    // 初始化值
    answered: [String, Array],
    // 选项是否正确
    wasCorrect: Boolean,

    disableReset: Boolean,
    // 禁止选项（查看记录时使用）
    disableForm: Boolean,
    // 选项
    options: Array,
    // 解析功能
    analysis: {
      type: String,
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return ['normal', 'never', 'always'].indexOf(value) !== -1
      },
      default: 'never',
    },
    // 解析内容
    analysisStr: String,
    // 是否必填
    required: Boolean,
    // 是否有下一题
    btnDown: Boolean,
    // 是否有上一题
    btnUp: Boolean,
    // 是否答题完后不可修改
    changable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // 答题结果
      answerResult: null,
      // 多选题结果
      checkbox: [],
      // 单选题结果
      radio: null,

      // 是否显示解析
      showAnalysis: false,

      // 结果是否正确
      isCorrect: false,

      saving: false, // 选完题后的定时器时差， 不允许用户频繁随意切换选项

      formatObj: {
        alphabet: (e) => {
          return String.fromCharCode(65 + parseInt(e))
        },
        symbol: {
          0: '正确',//'<i class="material-icons">check</i>',
          1: '错误'//'<i class="material-icons">close</i>',
        },
      },
      openSimple: false,
      dialogText:
        '第' + (this.index * 1 + 1) + '题选项没有正确答案，请联系管理员',
    }
  },
  computed: {
    ansOptStr() {
      const _res = this.getCorrectAnswerOpt()
      return this.isMultipleSubject ? _res.join(',') : _res
    },
    isMultipleSubject() {
      return this.type === 2
    },
    userAnsIdStr() {
      // const mId = this.checkboxId
      //    const sId = this.currentAnswerId
      // console.log('isMultipleSubject', this.isMultipleSubject)
      // console.log('answerResult', this.answerResult)
      return this.answerResult
    },
    // 外部引用
    testParams() {
      const _par = {
        is_correct: this.isCorrectAnswer(this.currentAnswer) ? 1 : 0, // 0 1
        item_id: this.userAnsIdStr, // string
      }
      console.log(
        `testParams 模拟考试选项参数，  回答是否正确: ${_par.is_correct} ， 选项id: ${_par.item_id}`
      )
      return _par
    },
  },

  watch: {
    // 切换题目时 重置
    questionId: {
      handler: function () {
        // 重置选项
        this.checkbox = []
        this.radio = null
        if (this.isMultipleSubject && this.answered) {
          this.checkbox = this.answered.split(',')
        } else {
          this.radio = this.answered * 1
        }
        for (let index = 0; index < this.checkbox.length; index++) {
          this.checkbox[index] = this.checkbox[index] * 1
        }
        console.log('this.checkbox', this.checkbox)
        console.log('this.radio', this.radio)

        if (
          (this.changable && this.checkbox && this.checkbox.length > 0) ||
          this.radio
        ) {
          // 题目初始化时，选项可改变 但已有选择答案时，修改选项不可修改
          this.$emit('update:changable', false)
        }

        // 获取答题结果
        let answerResult = this.getAnswerResult()
        let isCorrect = this.isCorrectAnswer()

        // 更新结果
        this.answerResult = answerResult
        this.isCorrect = isCorrect

        if (this.analysis == 'always') {
          this.showAnalysis = true
        } else if (this.analysis == 'never') {
          this.showAnalysis = false
        } else {
          if (!isCorrect && answerResult) {
            this.showAnalysis = true
          } else {
            this.showAnalysis = false
          }
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    // 点击选项
    clickOption() {
      // 获取答题结果
      let answerResult = this.getAnswerResult()
      let isCorrect = this.isCorrectAnswer()

      if (!isCorrect && this.analysis === 'normal' && !this.isMultipleSubject)
        this.showAnalysis = true

      if (!this.isMultipleSubject) {
        // 章节练习答完题目后不可修改选项
        // 多选题在点击下一题时不可再选 逻辑在down()方法内
        this.$emit('update:changable', false)
      }
      // 与上次结果进行判断
      if (answerResult != this.answerResult) {
        this.answerResult = answerResult
        this.isCorrect = isCorrect

        // 触发值改变事件
        this.$emit('changeValue', answerResult, isCorrect)
      }
    },
    getAnswerResult() {
      if (this.isMultipleSubject) {
        console.log('checkbox', this.checkbox)
        return this.checkbox
          .sort(function (a, b) {
            return a * 1 - b * 1
          })
          .join(',')
      } else {
        return this.radio
      }
    },

    hitControl(index) {
      const ctr = this.$refs.control[index].querySelector(
        '.subject-option-button'
      )
      ctr && ctr.click()
    },
    isRequiredFail() {
      if (!this.required) return false

      let isFail = false
      if (this.currentAnswer) {
        isFail = this.isMultipleSubject
          ? this.currentAnswer.length <= 0
          : this.currentAnswer === null
      } else {
        isFail = true
      }

      if (isFail) {
        this.$NewToast.message('选项不能为空')
      }

      return isFail
    },

    optStr(index, title) {
      const m1 = this.format(index)
      const m2 = this.type !== 5 ? `） ${title}` : ''
      return `${m1}${m2}`
    },

    format(value) {
      return this.type === 5
        ? this.formatObj.symbol[value]
        : this.formatObj.alphabet(value)
    },

    // 获取正确答案选项
    getCorrectAnswerOpt() {
      const items = this.options
      let res
      if (this.isMultipleSubject) {
        res = []
        items.map((e, i) => {
          if (e.is_answer === 1) {
            res.push(this.format(i))
          }
        })
      } else {
        for (let i = 0; i < items.length; i++) {
          if (items[i].is_answer == 1) {
            res = this.format(i)
            break
          }
        }
      }

      console.log(1111111, res)

      if (!res) {
        this.openSimple = true
        console.log(
          'SubjectOptions.vue::method.getCorrectAnswerOpt 选项没有正确答案(is_answer没有1)'
        )
        // throw new Error(
        //   'SubjectOptions.vue::method.getCorrectAnswerOpt 选项没有正确答案(is_answer没有1)'
        // )
      }

      return res
    },

    // 获取正确答案值
    getCorrectAnswer() {
      const items = this.options
      let correct
      if (this.isMultipleSubject) {
        let answerArray = []
        items.map((e) => {
          if (e.is_answer === 1) {
            answerArray.push(e.id)
          }
        })
        correct = answerArray
          .sort(function (a, b) {
            a - b
          })
          .join(',')
      } else {
        for (let i = 0; i < items.length; i++) {
          if (items[i].is_answer == 1) {
            correct = items[i].id
            break
          }
        }
      }

      if (!correct) {
        this.openSimple = true
        console.log(
          'SubjectOptions.vue::method.getCorrectAnswerOpt 选项没有正确答案(is_answer没有1)'
        )
        // throw new Error(
        //   'SubjectOptions.vue::method.getCorrectAnswer 选项没有正确答案(is_answer没有1)'
        // )
      }

      return correct
    },
    // 判断答案是否正确
    isCorrectAnswer() {
      let correctAnswer = this.getCorrectAnswer()
      let answer = this.getAnswerResult()

      return correctAnswer === answer
    },

    // 点击上一题
    emitUp() {
      this.$emit('up')
    },
    // 点击下一题
    emitDown() {
      if (this.isRequiredFail()) return

      let answerResult = this.getAnswerResult()
      let isCorrect = this.isCorrectAnswer()
      if (isCorrect) {
        this.$emit('down')
      } else if (
        answerResult &&
        this.analysis === 'normal' &&
        this.isMultipleSubject
      ) {
        this.$emit('update:changable', false)
        if (this.showAnalysis) {
          this.$emit('down')
        }
        this.showAnalysis = true
      } else {
        this.$emit('down')
      }
      if (!this.btnDown) {
        this.$NewToast.message('已完成最后一题')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.pic-video {
  display: flex;
  flex-flow: column;
}
.subject-title-icon {
  width: 100%;
  margin-bottom: 5px;
  display: flex;
}
.video {
  width: 100%;
  margin-top: 10px;
}
</style>
